// src/enums/common.ts
var Environment = /* @__PURE__ */ ((Environment2) => {
  Environment2["Development"] = "development";
  Environment2["Test"] = "test";
  Environment2["Production"] = "production";
  return Environment2;
})(Environment || {});
var ApiStatus = /* @__PURE__ */ ((ApiStatus2) => {
  ApiStatus2["Success"] = "success";
  ApiStatus2["Error"] = "error";
  return ApiStatus2;
})(ApiStatus || {});
var HealthStatus = /* @__PURE__ */ ((HealthStatus2) => {
  HealthStatus2["Ok"] = "ok";
  HealthStatus2["Degraded"] = "degraded";
  HealthStatus2["Down"] = "down";
  return HealthStatus2;
})(HealthStatus || {});
var RequestSource = /* @__PURE__ */ ((RequestSource2) => {
  RequestSource2["Body"] = "body";
  RequestSource2["Query"] = "query";
  RequestSource2["Cookies"] = "cookies";
  return RequestSource2;
})(RequestSource || {});
var SyncStatus = /* @__PURE__ */ ((SyncStatus2) => {
  SyncStatus2["PENDING"] = "PENDING";
  SyncStatus2["SYNC"] = "SYNC";
  SyncStatus2["SYNC_ADD"] = "SYNC_ADD";
  return SyncStatus2;
})(SyncStatus || {});

// src/enums/account.ts
var AccountSide = /* @__PURE__ */ ((AccountSide2) => {
  AccountSide2["CHAN"] = "CHAN";
  AccountSide2["LE"] = "LE";
  return AccountSide2;
})(AccountSide || {});

// src/enums/game.ts
var GameType = /* @__PURE__ */ ((GameType2) => {
  GameType2["TX"] = "TX";
  GameType2["XD"] = "XD";
  GameType2["TL"] = "TL";
  return GameType2;
})(GameType || {});
var GameBetKey = /* @__PURE__ */ ((GameBetKey2) => {
  GameBetKey2["TAI"] = "TAI";
  GameBetKey2["XIU"] = "XIU";
  GameBetKey2["CHAN"] = "CHAN";
  GameBetKey2["LE"] = "LE";
  GameBetKey2["_4T"] = "4T";
  GameBetKey2["_4D"] = "4D";
  GameBetKey2["_3T1D"] = "3T1D";
  GameBetKey2["_3D1T"] = "3D1T";
  return GameBetKey2;
})(GameBetKey || {});

// src/enums/permission.ts
var PermissionModule = /* @__PURE__ */ ((PermissionModule2) => {
  PermissionModule2["USER"] = "USER";
  PermissionModule2["ACCOUNT"] = "ACCOUNT";
  PermissionModule2["PROXY"] = "PROXY";
  PermissionModule2["GROUP"] = "GROUP";
  PermissionModule2["BETLOG"] = "BETLOG";
  PermissionModule2["TRANSACTION"] = "TRANSACTION";
  return PermissionModule2;
})(PermissionModule || {});
var PermissionAction = /* @__PURE__ */ ((PermissionAction2) => {
  PermissionAction2["CREATE"] = "CREATE";
  PermissionAction2["DELETE"] = "DELETE";
  PermissionAction2["UPDATE"] = "UPDATE";
  PermissionAction2["READ"] = "READ";
  PermissionAction2["READ_ONE"] = "READ_ONE";
  PermissionAction2["READ_MY"] = "READ_MY";
  PermissionAction2["CHECK_HEALTH"] = "CHECK_HEALTH";
  PermissionAction2["SYNC"] = "SYNC";
  return PermissionAction2;
})(PermissionAction || {});

// src/enums/role.ts
var RoleType = /* @__PURE__ */ ((RoleType2) => {
  RoleType2["ADMIN"] = "ADMIN";
  RoleType2["USER"] = "USER";
  return RoleType2;
})(RoleType || {});

// src/enums/user.ts
var UserStatus = /* @__PURE__ */ ((UserStatus2) => {
  UserStatus2["ACTIVE"] = "ACTIVE";
  UserStatus2["INACTIVE"] = "INACTIVE";
  return UserStatus2;
})(UserStatus || {});

// src/enums/betlog.ts
var BetLogServiceName = /* @__PURE__ */ ((BetLogServiceName2) => {
  BetLogServiceName2["TX"] = "T\xE0i X\u1EC9u Livestream";
  BetLogServiceName2["XD"] = "XD";
  BetLogServiceName2["TL"] = "TL";
  return BetLogServiceName2;
})(BetLogServiceName || {});
export {
  AccountSide,
  ApiStatus,
  BetLogServiceName,
  Environment,
  GameBetKey,
  GameType,
  HealthStatus,
  PermissionAction,
  PermissionModule,
  RequestSource,
  RoleType,
  SyncStatus,
  UserStatus
};
//# sourceMappingURL=index.js.map